module.exports = __webpack_public_path__ + "static/media/tp-login.d3fd036a.png";